import TileMinedLogic from "../../../logic/TileMinedLogic";
import { CharacterAction } from "../CharacterAction";
import PartyCharacter from "../PartyCharacter";
import TurnAction from "./TurnAction";

export default class MineTurnAction extends TurnAction {
    /**
     * @param {TileMinedLogic} tileMinedLogic
     */
    constructor(tileMinedLogic) {
        super();

        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;
    }

    /**
     * @override
     * @param {PartyCharacter} character The character making the turn action.
     * @param {number} frameTimeRatio The time frame ratio.
     * @param {boolean} turnStart True if this is the start of a turn.
     */
    performAction(character, frameTimeRatio, turnStart) {

        const tile = character.position.tile;
        if (!tile) {
            character.resetTurnState();
            return;
        }

        const mineTile = character.target.mineTile;

        if (!mineTile) {
            character.resetTurnState();
            return;
        }

        // If the target is open, then there is no point in mining.
        if (mineTile.open) {
            character.resetTurnState();
            return;
        }

        if (!tile.isNeighborTile(mineTile)) {
            character.resetTurnState();
            return;
        }

        // Show that the miner is actively mining. 
        character.setCharacterAction(CharacterAction.MINE);

        // Set the direction
        if (character.position.worldCoordinateOrigin.x !== mineTile.origin.x) {
            character.position.facingLeft = character.position.worldCoordinateOrigin.x > mineTile.origin.x;
        }

        // We only actually do mining once per turn.
        if (!turnStart) {
            return;
        }

        if (this.tileMinedLogic.mineTileForTurn(character, mineTile)) {
            character.resetTurnState();
        }
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'MineTurnAction';
    }
}